var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTikTok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98908 13.2589C7.32408 13.2589 8.40631 12.3032 8.40631 10.8417V0H11.3052C11.1426 1.97723 13.1082 3.88718 15.2759 3.8435V6.56947C13.4221 6.56947 11.8457 5.78561 11.297 5.35059V10.8417C11.297 13.2589 9.39541 16 5.98908 16C2.58275 16 0.722656 13.2589 0.722656 10.8417C0.722656 7.43001 4.33309 5.45136 6.72436 5.93497V8.71154C6.60406 8.66898 6.29384 8.60606 6.0296 8.60606C4.68352 8.55644 3.57185 9.6482 3.57185 10.8417C3.57185 12.1767 4.65408 13.2589 5.98908 13.2589Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTok);
export default __webpack_public_path__ + "static/media/TikTok.c901141414028c7b5ca63e2b634dbc13.svg";
export { ForwardRef as ReactComponent };